import React from "react";
import { useIntl } from "react-intl";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import $ from "jquery";

import PropTypes from "prop-types";

const DeleteModalId = "DeleteModalId";

const DeleteModal = (props) => {
    const intl = useIntl();

    if (props.showModalOnInit) {
        $(document).ready(function () {
            $("#" + DeleteModalId).modal("show");
        });
    }
    return (
        <div id={DeleteModalId} className="modal fade">
            <div className={"modal-dialog modal-confirm modal-dialog-centered"}>
                <div className="modal-content">
                    <div className="modal-header flex-column">
                        <div className="icon-box warning">
                            <FontAwesomeIcon icon={props.icon} />
                        </div>
                        <h4 className="modal-title w-100">{props.title}</h4>
                        <button id="deleteModalDismissButton" type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    </div>
                    <div className="modal-body">{props.children}</div>
                    <div className="modal-footer justify-content-center align-self-center">
                        <button id="deleteModalSecondButton" type="button" className="btn btn-secondary" data-dismiss="modal">{intl.messages.cancel}</button>
                        <button id="deleteModalFirstButton" type="button" className="btn btn-danger" data-dismiss="modal" onClick={props.onClick}>{props.btnlabel || intl.messages.ok}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

DeleteModal.defaultProps = {
    showModalOnInit: false
}

DeleteModal.propTypes = {
    title: PropTypes.string,
    btnlabel: PropTypes.string,
    icon: PropTypes.object,
    onClick: PropTypes.func,
    showModalOnInit: PropTypes.bool
};

export default DeleteModal;